import { ChangeEvent, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import AddJobAllJobsProfile from "../../StylesWrappers/General/AddJobAllJobsProfile";
import InputWrapper from "../../StylesWrappers/General/inputBox";
import InputBox from "../../components/General/InputBox";
import ButtonWrapper from "../../StylesWrappers/General/button";
import Button from "../../components/General/Button";
import { AppDispatch, RootState } from "../../store";
import { ProfileState } from "../../model";
import {
  collectInputs,
  getUserProfile,
  updateProfile,
} from "../../features/profile/profileSlice";
import TitleText from "../../components/General/Helmet";
import InputSkeleton from "../../components/Skeletons/InputSkeleton";
import { toast } from "react-toastify";
import { toastMessage } from "../../utils/toastMessage";

const Profile = () => {
  const { userProfile, profileLoading } = useSelector(
    (store: RootState) => store.profileStore
  );

  const { _id, username, firstName, lastName, email, location }: any =
    userProfile;

  const dispatch = useDispatch<AppDispatch>();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    let name = e.target.name as keyof ProfileState;
    let value = e.target.value;

    dispatch(collectInputs({ name, value }));
  };

  // Function to handle click of update profile button
  const handleSaveChanges = async (e: React.FormEvent<Element>) => {
    e.preventDefault();

    if (!username || !firstName || !lastName || !email) {
      toastMessage(
        "Username, first name, last name and email fields cannot be empty",
        dispatch,
        toast.error
      );
      return;
    }

    dispatch(updateProfile({ location, _id, dispatch }));
  };

  // Track data from database
  useEffect(() => {
    dispatch(getUserProfile());
  }, [dispatch]);

  if (profileLoading) {
    return <InputSkeleton inputSkel={5} />;
  }

  return (
    <AddJobAllJobsProfile>
      <TitleText title="Jobtrackier - Profile" />
      <p style={{ fontSize: "24px", fontWeight: 600, marginBottom: "1rem" }}>
        Profile
      </p>
      <InputWrapper>
        <div className="profile__container">
          {(
            <InputBox
              jobName="Username"
              typeName="text"
              inputName="username"
              inputValue={username}
              noEdit={true}
              inputStyle={{ cursor: "not-allowed" }}
            />
          ) || <Skeleton />}
          <InputBox
            jobName="First Name"
            typeName="text"
            inputName="firstName"
            inputValue={firstName}
            noEdit={true}
            inputStyle={{ cursor: "not-allowed" }}
          />
          <InputBox
            jobName="Last Name"
            typeName="text"
            inputName="lastName"
            inputValue={lastName}
            noEdit={true}
            inputStyle={{ cursor: "not-allowed" }}
          />
          <InputBox
            jobName="Email"
            typeName="email"
            inputName="email"
            inputValue={email}
            noEdit={true}
            inputStyle={{ cursor: "not-allowed" }}
          />
          <InputBox
            jobName="Location"
            typeName="text"
            inputName="location"
            inputValue={location}
            handleChange={handleChange}
          />
          <ButtonWrapper>
            <Button
              button="Save Changes"
              handleSubmit={handleSaveChanges}
              type="submit"
              allJobsBtn="add-profile-btn"
              btnStyle={{
                cursor: `${profileLoading ? "not-allowed" : ""}`,
              }}
            />
          </ButtonWrapper>
        </div>
      </InputWrapper>
    </AddJobAllJobsProfile>
  );
};

export default Profile;
